
import React from 'react';

export const FeaturesSection: React.FC = () => {
  const features = [
    {
      label: "SPEED",
      title: "Lightning Fast Connections",
      description: "Experience blazing-fast internet speeds with our optimized server network and advanced protocols.",
      points: [
        "Unlimited bandwidth with no throttling",
        "Optimized servers for maximum performance", 
        "Smart routing for fastest connections",
        "No speed limits or data caps"
      ],
      image: "https://public.readdy.ai/ai/img_res/979ace405de11ed94b579b06855ad069.jpg",
      reverse: false
    },
    {
      label: "SECURITY", 
      title: "Advanced Kill Switch Protection",
      description: "Automatic protection that instantly cuts your internet connection if the VPN drops, preventing data leaks.",
      points: [
        "Automatic connection monitoring",
        "Instant disconnect on VPN failure",
        "Zero data leak guarantee", 
        "Always-on protection mode"
      ],
      image: "https://readdy.ai/api/search-image?query=VPN%20kill%20switch%20interface%20on%20smartphone%20screen%2C%20security%20dashboard%2C%20red%20warning%20indicators%2C%20protection%20enabled%20status%2C%20mobile%20app%20UI%20design%2C%20dark%20theme&width=400&height=500&seq=killswitch1&orientation=portrait",
      reverse: true
    },
    {
      label: "COMPATIBILITY",
      title: "Multi-Platform Support", 
      description: "Seamless protection across all your devices with native apps for every platform.",
      points: [
        "Desktop applications available",
        "Mobile apps for smartphones",
        "Browser extensions included",
        "Router configuration support"
      ],
      image: "https://readdy.ai/api/search-image?query=multiple%20devices%20showing%20VPN%20app%2C%20laptop%20smartphone%20tablet%2C%20cross-platform%20compatibility%2C%20unified%20design%20interface%2C%20tech%20gadgets%20on%20desk%2C%20modern%20workspace&width=500&height=400&seq=devices1&orientation=landscape", 
      reverse: false
    }
  ];

  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {features.map((feature, index) => (
          <div key={index} className={`grid lg:grid-cols-2 gap-16 items-center ${index < features.length - 1 ? 'mb-24' : ''}`}>
            {feature.reverse ? (
              <>
                <div className="order-2 lg:order-1 space-y-8">
                  <div>
                    <div className="inline-block bg-purple-100 px-4 py-2 rounded-full mb-6">
                      <span className="text-purple-700 font-medium text-sm uppercase tracking-wide">
                        {feature.label}
                      </span>
                    </div>
                    <h3 className="text-4xl font-bold text-gray-900 mb-6">{feature.title}</h3>
                    <p className="text-lg text-gray-600 leading-relaxed mb-8">
                      {feature.description}
                    </p>
                  </div>
                  
                  <div className="space-y-4">
                    {feature.points.map((point, pointIndex) => (
                      <div key={pointIndex} className="flex items-start space-x-4">
                        <div className="w-6 h-6 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                          <i className="ri-check-line text-purple-600 text-sm"></i>
                        </div>
                        <span className="text-gray-700 leading-relaxed">{point}</span>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div className="order-1 lg:order-2">
                  <img 
                    src={feature.image}
                    alt={feature.title}
                    className="w-full h-auto rounded-2xl shadow-xl object-cover"
                  />
                </div>
              </>
            ) : (
              <>
                <div className="space-y-8">
                  <div>
                    <div className="inline-block bg-purple-100 px-4 py-2 rounded-full mb-6">
                      <span className="text-purple-700 font-medium text-sm uppercase tracking-wide">
                        {feature.label}
                      </span>
                    </div>
                    <h3 className="text-4xl font-bold text-gray-900 mb-6">{feature.title}</h3>
                    <p className="text-lg text-gray-600 leading-relaxed mb-8">
                      {feature.description}
                    </p>
                  </div>
                  
                  <div className="space-y-4">
                    {feature.points.map((point, pointIndex) => (
                      <div key={pointIndex} className="flex items-start space-x-4">
                        <div className="w-6 h-6 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                          <i className="ri-check-line text-purple-600 text-sm"></i>
                        </div>
                        <span className="text-gray-700 leading-relaxed">{point}</span>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div>
                  <img 
                    src={feature.image}
                    alt={feature.title}
                    className="w-full h-auto rounded-2xl shadow-xl object-cover"
                  />
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};
